<template>
  <footer class="primary d-flex mt-auto overflow-hidden">
    <v-container class="py-0">
      <v-row class="mb-10" justify-md="space-between" justify="center">
        <v-col cols="8" sm="4" md="4" lg="2" class="mt-10">
          <router-link to="/">
            <img
              v-if="banners.img_brand"
              :src="logo ? logo : files + banners.img_brand"
              :alt="informations.name"
              class="d-block filter-white"
              width="100%"
            />
          </router-link>
        </v-col>
        <v-col
          v-if="informationsContacts.call_center"
          cols="12"
          sm="6"
          md="6"
          lg="3"
          class="mt-10"
        >
          <div
            class="white--text text-h6 text-md-h5 font-weight-medium item-title"
          >
            Central de Atendimento
          </div>

          <div
            v-html="informationsContacts.call_center"
            class="text-caption white--text mt-3 item-text"
          ></div>
        </v-col>
        <v-col
          v-if="informationsContacts.hours"
          cols="12"
          sm="6"
          md="6"
          lg="3"
          class="mt-10"
        >
          <div
            class="white--text text-h6 text-md-h5 font-weight-medium item-title"
          >
            Horários
          </div>

          <div
            v-html="informationsContacts.hours"
            class="text-caption white--text mt-3 item-text"
          ></div>
        </v-col>
        <v-col
          v-if="social.length"
          cols="12"
          sm="6"
          md="6"
          lg="3"
          class="mt-10"
        >
          <div
            class="white--text text-h6 text-md-h5 font-weight-medium item-title"
          >
            Nossos Canais
          </div>

          <div class="mx-n5">
            <v-btn
              rounded
              depressed
              height="40px"
              min-width="auto"
              width="40px"
              :href="link"
              target="_blank"
              color="white"
              class="ml-2"
              :title="title"
              text
              v-for="({ title, link, icon, size }, keySocial) in social"
              :key="keySocial"
            >
              <v-icon :size="size"> {{ icon }} </v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <v-sheet
        min-height="60px"
        class="
          transparent
          white--text
          d-flex
          justify-space-between
          align-center
          flex-column flex-sm-row
          py-4 py-sm-0
        "
      >
        <v-row justify="space-between">
          <v-col cols="12" sm="auto">
            <div class="text-center copyright">
              Copyright @ {{ year }} <b>{{ informations.short_name }}</b
              >. Todos os Direitos Reservados.
            </div>
          </v-col>
          <v-col cols="12" sm="auto">
            <a href="https://mrxweb.com.br/" target="_blank">
              <img
                class="mx-auto mx-sm-0 d-block"
                src="/img/mrxweb.svg"
                height="20px"
                alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
                title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
              />
            </a>
          </v-col>
        </v-row>
      </v-sheet>
    </v-container>
  </footer>
</template>

<script>
import { getSocial } from "../../config";

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
    logo: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    year: new Date().getFullYear(),
    banners: {},
    informations: {},
    informationsContacts: {},
    social: [],
  }),
  mounted() {
    this.$rest("pages-informations").get({
      id: this.mod,
      save: (state, data) => (this.informations = data),
    });

    this.$rest("pages-informations-medias").get({
      id: this.mod,
      save: (state, data) => (this.social = data),
    });

    this.$rest("pages-banners").get({
      id: this.mod,
      save: (state, data) => (this.banners = data),
    });

    this.$rest("pages-informations-contacts").get({
      id: this.mod,
      save: (state, data) => (this.informationsContacts = data),
    });

    this.$rest("pages-informations-medias").get({
      id: this.mod,
      save: (state, data) => (this.social = getSocial(data)),
    });
  },
  methods: {
    getSocial,
  },
};
</script>
<style lang="scss" scoped>
.item-text::v-deep p {
  text-align: start !important;
}
</style>
